import { render, staticRenderFns } from "./EnquiryStatusChange.vue?vue&type=template&id=0cf2c14a&"
import script from "./EnquiryStatusChange.vue?vue&type=script&lang=js&"
export * from "./EnquiryStatusChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QItemSection,QItemLabel,QBadge} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QItem,QItemSection,QItemLabel,QBadge})
